
export default {

    productClaims(state){
        return state.productClaims
    },

    userProductClaims(state){
        return state.userProductClaims
    },

    totalProductSold(state){
        return state.totalProductSold
    },

    totalProductPV(state){
        return state.totalProductPV
    },

    sumClaimedProducts(state){
        return state.sumClaimedProducts
    }
}